<template>
    <dialog-template v-bind="$attrs"
        v-on="$listeners"
        width="400px"
        @update:visible="updateVisible"
        @open="show"
        @opened="opened">
        <div slot="title" class="fx-v-center color-333" style="height: 100%">
            <h1 class="fs-16 fw-600 lh-22">{{ headerTitle }}</h1>
            <span v-if="isShowDel"
                class="href ml-12 fs-14 color-red"
                @click="delClick">删除</span>
        </div>
        <el-input v-if="realMode !== 'delete'"
            v-model="elIptVal"
            ref="elIpt"
            placeholder="请输入支付方式名称"
            :show-word-limit="true"
            :maxlength="6" />
        <h2 v-else class="color-333 fs-16 fw-600 lh-22 align-c">确认删除该支付方式吗？</h2>
        <div slot="footer" class="fx-center">
            <el-button v-if="realMode !== 'delete'"
                type="primary"
                size="medium"
                :loading="isConfirmLoading"
                :disabled="elIptVal.trim() === ''"
                @click="confirm">确认</el-button>
            <el-button v-else
                type="danger"
                size="medium"
                :loading="isDelLoading"
                @click="delConfirm">确认</el-button>
            <el-button type="default"
                size="medium"
                @click="cancel">取消</el-button>
        </div>
    </dialog-template>
</template>

<script lang="ts">
import { createComponent, ref, computed, onMounted, onBeforeMount } from '@vue/composition-api'
import { openMessage } from '../../../utils/system'
import $fetch from '../../../api'

export default createComponent({
    props: {
        mode: {
            type: String,
            default: 'create'
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        customPaymentconfigId: Number
    },

    setup: (props, ctx) => {
        const isConfirmLoading = ref(false)
        const isDelLoading = ref(false)
        const realMode = ref(props.mode)
        const elIptVal = ref('')

        const headerTitle = computed(() => {
            const obj = {
                create: '新增支付方式',
                update: '编辑支付方式',
                delete: '系统提示'
            }

            return obj[realMode.value]
        })

        const isShowDel = computed(() => {
            return realMode.value === 'update' ? true : false
        })

        function show() {
            realMode.value = props.mode
        }

        function opened() {
            (ctx.refs as any).elIpt.focus()
        }

        function delClick() {
            if (props.canDelete) {
                realMode.value = 'delete'
            } else {
                openMessage('error', '该支付方式已产生历史数据，不允许删除')
            }
        }

        function updateVisible() {
            ctx.emit('update:visible', false)
        }

        async function delConfirm() {
            try {
                isDelLoading.value = true
                await $fetch.post({
                    url: '/shop/editcustompaymentconfig',
                    params: {
                        custom_paymentconfig_id: props.customPaymentconfigId,
                        status: -1
                    }
                })
                ctx.emit('success')
                cancel()
                openMessage('success', '支付方式删除成功')
            } catch (e) {
                cancel()
                openMessage('error', e.message || '删除失败')
            }
        }

        async function confirm() {
            try {
                isConfirmLoading.value = true
                let params
                if (props.mode === 'create') {
                    params = {
                        status: 1,
                        name: elIptVal.value
                    }
                } else {
                    params = {
                        custom_paymentconfig_id: props.customPaymentconfigId,
                        name: elIptVal.value
                    }
                }
                await $fetch.post({
                    url: '/shop/editcustompaymentconfig',
                    params
                })
                ctx.emit('success')
                cancel()
                openMessage('success', props.mode === 'create' ? '支付方式新建成功' : '支付方式编辑成功')
            } catch (e) {
                cancel()
                openMessage('error', e.message || '修改失败')
            }
        }

        function cancel() {
            ctx.emit('update:visible', false)
            setTimeout(() => {
                isConfirmLoading.value = false
                isDelLoading.value = false
                elIptVal.value = ''
            }, 600)
        }

        return {
            isShowDel,
            isConfirmLoading,
            isDelLoading,
            realMode,
            elIptVal,
            headerTitle,
            delConfirm,
            confirm,
            cancel,
            show,
            opened,
            delClick,
            updateVisible
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-input .el-input__inner {
    padding-left: 8px;
}
</style>
